"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFunction = void 0;
const assert_1 = require("../../assert");
const createSchemaValidator_1 = require("../createSchemaValidator");
function validateFunction(value) {
    if (!assert_1.assert.isFunction(value)) {
        return createSchemaValidator_1.ValidationResult.InvalidType;
    }
    return createSchemaValidator_1.ValidationResult.Valid;
}
exports.validateFunction = validateFunction;
//# sourceMappingURL=function.js.map